import { createAction } from '@reduxjs/toolkit';

const USER_LOADING = 'USER_LOADING';

export const userLoadingAction = createAction<{ isLoading: boolean }>(USER_LOADING);
